import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import guide from "./guideContent";

const mdComponents = {
  h1: (p) => <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight mt-2 mb-4" {...p} />,
  h2: (p) => <h2 className="font-heading text-2xl font-bold mt-10 mb-3 pb-2 border-b border-border" {...p} />,
  h3: (p) => <h3 className="font-heading text-lg font-semibold mt-6 mb-2" {...p} />,
  p: (p) => <p className="text-[15px] leading-relaxed text-foreground/85 my-3" {...p} />,
  ul: (p) => <ul className="list-disc pl-6 space-y-1.5 my-3 text-[15px] text-foreground/85" {...p} />,
  ol: (p) => <ol className="list-decimal pl-6 space-y-1.5 my-3 text-[15px] text-foreground/85" {...p} />,
  li: (p) => <li className="leading-relaxed" {...p} />,
  strong: (p) => <strong className="font-semibold text-foreground" {...p} />,
  em: (p) => <em className="italic text-muted-foreground" {...p} />,
  hr: () => <hr className="my-8 border-border" />,
  a: (p) => <a className="text-primary underline underline-offset-2" {...p} />,
  table: (p) => <div className="overflow-x-auto my-4"><table className="w-full border-collapse text-sm" {...p} /></div>,
  thead: (p) => <thead className="bg-secondary/60" {...p} />,
  th: (p) => <th className="border border-border px-3 py-2 text-left font-semibold" {...p} />,
  td: (p) => <td className="border border-border px-3 py-2 align-top text-foreground/85" {...p} />,
  blockquote: (p) => <blockquote className="border-l-4 border-primary/40 pl-4 italic text-muted-foreground my-4" {...p} />,
  code: (p) => <code className="rounded bg-secondary px-1.5 py-0.5 text-[13px] font-mono" {...p} />,
};

export default function Guide() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <Navbar subtitle="Guide" />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="guide-page">
        <Button variant="ghost" className="rounded-lg mb-4 -ml-2" onClick={() => navigate("/")} data-testid="guide-back-btn">
          <ArrowLeft className="h-4 w-4 mr-1.5" /> Back to app
        </Button>
        <article data-testid="guide-content">
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={mdComponents}>{guide}</ReactMarkdown>
        </article>
      </div>
    </div>
  );
}
